import { useGetCurrentTenantQuery } from 'store/api/tenants';
import { t } from 'utils/getTranslations';
import { useHasPermissions } from 'utils/permissionUtil';

const READ_TENANTS = ['READ.TENANTS'];

/**
 * The firm's base currency for a report: the one its rows came back in, else the tenant's for a user who may read
 * it, so a header can name it before the first rows arrive. Null when neither is known.
 */
export function useReportBaseCurrency(fromRows?: string | null): string | null {
    const canReadTenant = useHasPermissions(READ_TENANTS);
    const { data: tenant } = useGetCurrentTenantQuery(undefined, { skip: !canReadTenant || !!fromRows });
    return fromRows || tenant?.baseCurrencyTypeCode || null;
}

/** A base-currency amount's header with the currency after it, such as "Billable amount (EUR)". */
export function inBaseCurrency(header: string, currency: string | null): string {
    return currency ? t('reporting.column.in-currency', { header, currency }) : header;
}

/**
 * What the totals row shows under a Case currency or Invoice currency column: the currencies of the rows on the
 * page, in order, each once.
 */
export function rowCurrencies<Row>(rows: Row[] | undefined, currency: (row: Row) => string | null): string {
    const codes = (rows ?? []).map(currency).filter((code): code is string => !!code);
    return [...new Set(codes)].sort().join(', ');
}
